var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusinfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75 1.5C5.19365 1.5 1.5 5.19365 1.5 9.75C1.5 14.3063 5.19365 18 9.75 18C14.3063 18 18 14.3063 18 9.75C18 5.19365 14.3063 1.5 9.75 1.5ZM0 9.75C0 4.36522 4.36522 0 9.75 0C15.1348 0 19.5 4.36522 19.5 9.75C19.5 15.1348 15.1348 19.5 9.75 19.5C4.36522 19.5 0 15.1348 0 9.75ZM8.625 5.75C8.625 5.12868 9.12868 4.625 9.75 4.625H9.76C10.3813 4.625 10.885 5.12868 10.885 5.75V5.76C10.885 6.38132 10.3813 6.885 9.76 6.885H9.75C9.12868 6.885 8.625 6.38132 8.625 5.76V5.75ZM10.5 9.75C10.5 9.33579 10.1642 9 9.75 9C9.33579 9 9 9.33579 9 9.75V13.75C9 14.1642 9.33579 14.5 9.75 14.5C10.1642 14.5 10.5 14.1642 10.5 13.75V9.75Z",
    fill: "url(#paint0_linear_565_740)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_565_740",
    x1: 0,
    y1: 9.75,
    x2: 19.5,
    y2: 9.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E93FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3153C7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusinfo);
export default __webpack_public_path__ + "static/media/statusinfo.dcd780a8dfe618a965962f4086288be6.svg";
export { ForwardRef as ReactComponent };